/* DRT — turn the per-product Judge.me review widget into a horizontal carousel.
   Judge.me renders/re-renders the widget asynchronously (and varies its markup
   between builds), so instead of hard-coding the list container class we locate
   the review cards (.jdgm-rev — a stable class) and carousel their parent.
   No-op on pages without #judgeme_product_reviews (e.g. the homepage). */
(function () {
  var root = document.getElementById('judgeme_product_reviews');
  if (!root) return;

  var ARROW_PREV = '<svg viewBox="0 0 320 512" width="18" height="18" aria-hidden="true"><path fill="currentColor" d="M267.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4l-192 160L64 241V96c0-17.7-14.3-32-32-32S0 78.3 0 96V416c0 17.7 14.3 32 32 32s32-14.3 32-32V271l11.5 9.6 192 160z"/></svg>';
  var ARROW_NEXT = '<svg viewBox="0 0 320 512" width="18" height="18" aria-hidden="true"><path fill="currentColor" d="M52.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4S0 428.4 0 416V96C0 83.6 7.2 72.3 18.4 67s24.5-3.6 34.1 4.4l192 160L256 241V96c0-17.7 14.3-32 32-32s32 14.3 32 32V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V271l-11.5 9.6-192 160z"/></svg>';

  function findContainer() {
    var card = root.querySelector('.jdgm-rev');
    if (!card) return null;
    var c = card.parentNode;
    if (!c) return null;
    // only skip the widget root itself (flexing it would break the header/summary);
    // the dedicated reviews container (.jdgm-rev-widg__reviews / .jdgm-all-reviews__body) is fine.
    if (c === root || c.id === 'judgeme_product_reviews' ||
        c.classList.contains('jdgm-rev-widg') ||
        c.classList.contains('jdgm-all-reviews-widget') ||
        c.classList.contains('jdgm-all-reviews-widget-v2025')) return null;
    return c;
  }

  function enhance() {
    var list = findContainer();
    if (!list) return;
    // already wrapped?
    if (list.parentNode && list.parentNode.classList.contains('drt-jdgm-carousel-wrap')) {
      return;
    }
    // clean stale wrappers from a previous Judge.me re-render
    root.querySelectorAll('.drt-jdgm-carousel-wrap').forEach(function (w) {
      if (!w.querySelector('.jdgm-rev')) w.remove();
    });

    list.classList.add('drt-jdgm-carousel');
    var wrap = document.createElement('div');
    wrap.className = 'drt-jdgm-carousel-wrap';
    list.parentNode.insertBefore(wrap, list);
    wrap.appendChild(list);

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'drt-jdgm-arrow drt-jdgm-arrow--prev';
    prev.setAttribute('aria-label', 'Previous reviews');
    prev.innerHTML = ARROW_PREV;
    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'drt-jdgm-arrow drt-jdgm-arrow--next';
    next.setAttribute('aria-label', 'Next reviews');
    next.innerHTML = ARROW_NEXT;
    wrap.appendChild(prev);
    wrap.appendChild(next);

    function step(dir) {
      var card = list.querySelector('.jdgm-rev');
      var amount = card ? card.getBoundingClientRect().width + 16 : list.clientWidth * 0.8;
      list.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });

    function update() {
      var max = list.scrollWidth - list.clientWidth - 2;
      var noScroll = list.scrollWidth <= list.clientWidth + 2;
      wrap.classList.toggle('drt-jdgm--no-scroll', noScroll);
      prev.disabled = list.scrollLeft <= 0;
      next.disabled = list.scrollLeft >= max;
    }
    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    setTimeout(update, 200);
    update();
  }

  enhance();
  // Judge.me injects/re-renders the widget after load — keep watching.
  new MutationObserver(enhance).observe(root, { childList: true, subtree: true });
})();
